import axios from "./axios-config";

export const getAllOrders = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/orders?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleOrder = async (id) => {

    let { data } = await axios.get(`/super-admin/orders/` + id)
    return data;

}
export const deleteSingleBlog = async (id) => {
    let { data } = await axios.delete(`/super-admin/orders/` + id)
    return data;
}

export const updateSingleOrders = async (id, updateData) => {

    let { data } = await axios.post(`/super-admin/orders/${id}?_method=put`, updateData)
    return data;
}

export const getOrdersPayment = async (id) => {

    let { data } = await axios.get(`/super-admin/order/${id}/payments`)
    return data
}


// export const getBlogOrders = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Orders/all/orders`, data)
//     return data;
// }


